import { VStack, HStack, Icon } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";

const REVIEW_COUNT = 12;
const reviews = Array.from({ length: REVIEW_COUNT }, (_, i) => i + 1);

export const TrustSection = () => {
	const { t } = useTranslation();

	const stats = [
		{ value: t("home.trust.stat1Value") },
		{ value: t("home.trust.stat2Value") },
		{ value: t("home.trust.stat3Value") },
	];

	const topRow = reviews.slice(0, 6);
	const bottomRow = reviews.slice(6);

	return (
		<VStack className="w-full gap-[28px]">
			<VStack className="w-full max-w-[1200px] mx-auto gap-[28px] px-[20px] md:px-[60px]">
				<h2 className="text-[1.5rem] md:text-[2.25rem] text-ct-strong font-semibold text-center">
					{t("home.trust.title")}
				</h2>

				{/* 통계 카드 */}
				<HStack className="w-full gap-[20px] flex-wrap justify-center">
					{stats.map((stat, index) => (
						<motion.div
							key={index}
							className="w-full md:w-[280px]"
							initial={{ opacity: 0, scale: 0.9 }}
							whileInView={{ opacity: 1, scale: 1 }}
							viewport={{ once: true }}
							transition={{ delay: index * 0.1, duration: 0.5 }}
						>
							<VStack className="gap-[10px] p-[24px] rounded-[16px] bg-bg-regular">
								<span className="text-[2.25rem] text-pm-strong font-semibold">{stat.value}</span>
								<span className="text-md text-ct-regular font-medium text-center">
									{t(`home.trust.stat${index + 1}`)}
								</span>
							</VStack>
						</motion.div>
					))}
				</HStack>
			</VStack>

			{/* 리뷰 마퀴 - full width */}
			<VStack className="w-full gap-[16px] overflow-hidden">
				<MarqueeRow reviews={topRow} direction="left" />
				<MarqueeRow reviews={bottomRow} direction="right" />
			</VStack>
		</VStack>
	);
};

const MarqueeRow = ({ reviews, direction }: { reviews: number[]; direction: "left" | "right" }) => {
	const { t } = useTranslation();
	const items = [...reviews, ...reviews, ...reviews];

	return (
		<div
			className="flex gap-[16px] w-max"
			style={{
				animation: `marquee-${direction} ${reviews.length * 5}s linear infinite`,
			}}
		>
			<style>{`
				@keyframes marquee-left {
					0% { transform: translateX(0); }
					100% { transform: translateX(calc(-100% / 3)); }
				}
				@keyframes marquee-right {
					0% { transform: translateX(calc(-100% / 3)); }
					100% { transform: translateX(0); }
				}
			`}</style>
			{items.map((review, index) => (
				<VStack
					key={`${review}-${index}`}
					className="w-[320px] shrink-0 gap-[16px] p-[24px] rounded-[16px] bg-bg-regular items-start"
				>
					<HStack className="gap-[4px]">
						{[...Array(5)].map((_, i) => (
							<Icon key={i} name="Gyul" className="text-pm-strong" width={16} height={16} />
						))}
					</HStack>
					<p className="text-md text-ct-regular font-medium flex-1">
						"{t(`home.trust.review${review}.text`)}"
					</p>
					<VStack className="gap-[4px] items-start">
						<span className="text-sm text-ct-strong font-semibold">
							{t(`home.trust.review${review}.author`)}
						</span>
						<span className="text-sm text-ct-weak font-medium">
							{t(`home.trust.review${review}.position`)}
						</span>
					</VStack>
				</VStack>
			))}
		</div>
	);
};
